import { render, staticRenderFns } from "./OperaPlanGoodsSkuWindow.vue?vue&type=template&id=0678d71b&scoped=true&"
import script from "./OperaPlanGoodsSkuWindow.vue?vue&type=script&lang=js&"
export * from "./OperaPlanGoodsSkuWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaPlanGoodsSkuWindow.vue?vue&type=style&index=0&id=0678d71b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678d71b",
  null
  
)

export default component.exports